import React from 'react';
import { useTranslation } from 'react-i18next';
import ProductCard from '../components/ProductCard';

const ProductList = ({ products, selectedInterval, category }) => {
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language;

    const filteredProducts = products?.filter(({ product }) =>
        product?.metadata?.language?.toLowerCase() === currentLanguage
    );

    return (
        filteredProducts &&
        <div className="container mt-4">
            <div className="row g-4 justify-content-center">
                {filteredProducts.map(({ product, prices }) => (
                    <div key={product.id} className="col-12 col-md-6 col-lg-4">
                        <ProductCard
                            product={product}
                            prices={prices}
                            selectedInterval={selectedInterval}
                            category={category}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProductList;